import { useTranslation } from "react-i18next";
import { CodeBlock, DocsToc } from "../components";
import { DocsTocItem } from "../interfaces";
import {
  DOCS_ERRORS,
  ERROR_BODY_EXAMPLE,
  GATEWAY_UNAUTHORIZED_EXAMPLE,
} from "../utils";

const TOC_ITEMS: DocsTocItem[] = [
  { id: "errors-shape", translationKey: "docs.errors.shape.title", level: 1 },
  {
    id: "errors-gateway",
    translationKey: "docs.errors.gateway.title",
    level: 1,
  },
  {
    id: "errors-catalog",
    translationKey: "docs.errors.catalogTitle",
    level: 1,
  },
];

export const Errors = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col-reverse gap-8 lg:flex-row lg:gap-12">
      <div className="min-w-0 flex-1 space-y-12">
        <div className="space-y-4">
          <h2 className="text-xl font-bold lg:text-2xl">
            {t("docs.errors.title")}
          </h2>
          <p className="text-base/relaxed text-gray-400 lg:text-lg/relaxed">
            {t("docs.errors.intro")}
          </p>
        </div>

        <div className="space-y-4">
          <h3
            id="errors-shape"
            className="scroll-mt-6 text-lg font-bold lg:text-xl"
          >
            {t("docs.errors.shape.title")}
          </h3>
          <p className="text-base/relaxed text-gray-400 lg:text-lg/relaxed">
            {t("docs.errors.shape.content")}
          </p>
          <CodeBlock
            code={ERROR_BODY_EXAMPLE}
            language="json"
            syntax="json"
          />
        </div>

        <div className="space-y-4">
          <h3
            id="errors-gateway"
            className="scroll-mt-6 text-lg font-bold lg:text-xl"
          >
            {t("docs.errors.gateway.title")}
          </h3>
          <p className="text-base/relaxed text-gray-400 lg:text-lg/relaxed">
            {t("docs.errors.gateway.content")}
          </p>
          <CodeBlock
            code={GATEWAY_UNAUTHORIZED_EXAMPLE}
            language="json"
            syntax="json"
          />
        </div>

        <div className="space-y-4">
          <h3
            id="errors-catalog"
            className="scroll-mt-6 text-lg font-bold lg:text-xl"
          >
            {t("docs.errors.catalogTitle")}
          </h3>
          <div className="w-full overflow-x-auto">
            <table className="w-full min-w-[44rem] border-collapse text-left text-sm">
              <thead>
                <tr className="border-b border-gray-200">
                  <th
                    scope="col"
                    className="py-2 pr-4 font-semibold text-gray-700"
                  >
                    {t("docs.common.errorCode")}
                  </th>
                  <th
                    scope="col"
                    className="py-2 pr-4 font-semibold text-gray-700"
                  >
                    {t("docs.common.httpStatus")}
                  </th>
                  <th
                    scope="col"
                    className="py-2 pr-4 font-semibold text-gray-700"
                  >
                    {t("docs.common.meaning")}
                  </th>
                  <th scope="col" className="py-2 font-semibold text-gray-700">
                    {t("docs.common.whatToDo")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {DOCS_ERRORS.map((error) => (
                  <tr
                    key={`${error.httpCode}-${error.code}`}
                    className="border-b border-gray-100 align-top"
                  >
                    <td className="py-3 pr-4">
                      <code className="whitespace-nowrap font-mono text-xs text-primary sm:text-sm">
                        {error.code}
                      </code>
                    </td>
                    <td className="py-3 pr-4 font-mono text-xs text-gray-500">
                      {error.httpCode}
                    </td>
                    <td className="py-3 pr-4 leading-relaxed text-gray-500">
                      {t(`docs.errors.items.${error.translationKey}.meaning`)}
                    </td>
                    <td className="py-3 leading-relaxed text-gray-500">
                      {t(`docs.errors.items.${error.translationKey}.action`)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <DocsToc items={TOC_ITEMS} />
    </div>
  );
};
